export default __webpack_public_path__ + "static/media/gallery_09.b206788c.jpg";